import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import useUser from 'shared/hooks/use-user'
import type { UseQueryClearOptions } from 'shared/types/tanstack-utility-types'
import { schoolKeys } from '../api/key-factory'
import { MEMBERSHIP_API } from '../api/membership-api'
import type {
  SchoolCoursesOfCourseBundleApiInterface,
  SchoolEnrollmentId,
} from '../types/school-enrollments-interface'

interface UseEnrollmentsInterface extends UseQueryClearOptions<
  SchoolCoursesOfCourseBundleApiInterface,
  Error,
  SchoolCoursesOfCourseBundleApiInterface
> {
  schoolEnrollmentId: SchoolEnrollmentId | null
}

export function useCoursesOfCourseBundle({
  schoolEnrollmentId,
  ...options
}: UseEnrollmentsInterface): UseQueryResult<SchoolCoursesOfCourseBundleApiInterface> {
  const { user } = useUser()

  const { fetcher: listFetcher } = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.get,
    SchoolCoursesOfCourseBundleApiInterface
  >({ method: RequestMethodsEnum.get })

  return useQuery({
    queryKey: schoolKeys.bundle(schoolEnrollmentId),
    queryFn: async () => listFetcher(`${MEMBERSHIP_API}/enrollments/${schoolEnrollmentId}/bundle`),
    enabled: !!user && !!schoolEnrollmentId,
    gcTime: Infinity,
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: 'always',
    ...options,
  })
}
